import styles from "./Honeypot.module.scss";

function Honeypot({ value, onChange }) {
  return (
    <div className={styles.honeypot} aria-hidden="true">
      <label htmlFor="website">Site web</label>
      <input
        type="text"
        id="website"
        name="website"
        value={value}
        onChange={onChange}
        tabIndex="-1"
        autoComplete="off"
      />
    </div>
  );
}

export default Honeypot;
